import React from "react";
import './styles/Legal.css';


const CookiePolicy = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Cookie Policy for </h1>
      <h1 className="policy-subtitle">Newro (Operated by NWRWTS Pty Ltd) </h1>
      <p className="policy-updated">Last updated: June 4, 2025</p>

      <p className="policy-text">
        At Newro, we use cookies and similar tracking technologies to enhance your experience on our platform. This Cookie Policy explains what cookies are, how we use them, and your choices regarding their use.
      </p>

      <h3 className="policy-section">What Are Cookies?</h3>
      <p className="policy-text">
        Cookies are small text files placed on your device (computer, smartphone, or tablet) when you visit a website. They help websites recognize your device and remember information about your visit, such as your preferences and login status.
      </p>

      <h3 className="policy-section">How We Use Cookies</h3>
      <p className="policy-text">
        We use cookies to:
      </p>
      <ul className="policy-list">
        <li>Ensure the proper functioning of our website and platform</li>
        <li>Remember your login and user preferences</li>
        <li>Analyze site usage to improve performance and user experience</li>
        <li>Provide personalized recommendations and content</li>
        <li>Measure the effectiveness of our marketing campaigns</li>
      </ul>

      <h3 className="policy-section">Types of Cookies We Use</h3>
      <ul className="policy-list">
        <li><strong>Essential Cookies:</strong> Necessary for the operation of our platform (e.g., keeping you logged in, session management).</li>
        <li><strong>Performance and Analytics Cookies:</strong> Help us understand how users interact with our platform by collecting anonymous usage data.</li>
        <li><strong>Functional Cookies:</strong> Remember your preferences and settings to provide a more personalized experience.</li>
        <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertising and track marketing effectiveness.</li>
      </ul>

      <h3 className="policy-section">Third-Party Cookies</h3>
      <p className="policy-text">
        We may allow trusted third-party services (like analytics providers) to place cookies on your device to help us analyze traffic and improve our services. These third parties have their own privacy policies and practices.
      </p>

      <h3 className="policy-section">Your Choices</h3>
      <p className="policy-text">
        Most browsers allow you to control cookies through settings. You can:
      </p>
      <ul className="policy-list">
        <li>Accept or reject cookies</li>
        <li>Delete existing cookies</li>
        <li>Set preferences for specific websites</li>
      </ul>
      <p className="policy-text">
        Please note that disabling certain cookies may affect your ability to use some features of Newro.
      </p>

      <h3 className="policy-section">Changes to This Cookie Policy</h3>
      <p className="policy-text">
        We may update this Cookie Policy from time to time. We will notify you of any significant changes by posting the updated policy on our website.
      </p>

      <h3 className="policy-section">Contact Us</h3>
      <p className="policy-text">
        If you have questions about our use of cookies, please contact us at:<br />
        <strong>developer@newro.co.za</strong><br />
        NWRWTS Pty Ltd, Cape Town, South Africa
      </p>
    </div>
  );
};

export default CookiePolicy;
